export const logoutClearCookies = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("action");
    localStorage.removeItem("authHash");
    return true;
};

export const toSentenceCase = (text) => {
    return text.toLowerCase().replace(/(^\s*\w|\.\s*\w)/g, function (c) {
        return c.toUpperCase();
    });
};

export const validateEmail = (email) => {
    const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(email).toLowerCase())) return false;
    else return true;
};

export const validatePassword = (pass) => {
    //const re = /^(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,}$/;
    const re = /^(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~]{8,}$/;
    if (!re.test(pass)) return false;
    else return true;
};

export const validatePrice = (v) => {
    const re = /^([1-9]\d*|0,[0-9]*[1-9])?(,\d\d?)?$/;
    if (!re.test(v)) return false;
    else return true;
};

export const daysLater = (date, days) => {
    const today = new Date(date);
    return new Date(today.setDate(today.getDate() + days));
};
